import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { Button, Box } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import swal from 'sweetalert';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';

import { Radio, RadioGroup, FormLabel } from '@mui/material';

const AddWorkShopParticpant = () => {
  const history = useHistory();
  const [workshopCategoryData, setWorkShopCategoryData] = useState([]);
  const [workShopJoinAsData, setWorkShopJoinAsData] = useState([]);
  
  const [disabled, setdisabled] = useState(false);
  const [isChecked, setChecked] = useState(false);
  const eventName = localStorage.getItem('eventname');
  const eventid = localStorage.getItem('eventid');
  const [nameTitle, setNameTitle] = useState('');
  const [joinAs, setjoinAs] = useState('');
  const [gender, setGender] = useState(''); // state to hold the selected value
  const [country, setCountry] = useState('Saudi Arabia');
  const [registrationType, setRegistrationType] = useState('');
  const [assignModule, setassignModules] = useState([]);
  const [checkmodules, setCheckedmodules] = useState([]);
  const [addWorkShopParticpant, setAddWorkShopParticpant] = React.useState({
    name: "",
    instituteWorkPlace: "",
    city: "",
    phone: "",
    email: "",
    saudiCouncilno: "",
    price: "",
    // password: "",
    // phone: "",
    // date: "",
    // address: "",
    // details: "",
    error_list: [],
  });
  useEffect(() => {
    axios.get(`api/workshop-category-front-index?id=${eventid}`).then(res => {
      if (res.status == 200) {
        const wcategoryData = res.data.workshopCategories;
        setWorkShopCategoryData(wcategoryData);
      }
      else {
        swal('Error', "Check API Something Wrong", 'error');

      }


    });

  }, []);

  useEffect(() => {
    axios.get(`api/get-workshop-particpant-join-as?id=${eventid}`).then(res => {
      if (res.status == 200) {
        const wJoinAsData = res.data.gwpj;
        setWorkShopJoinAsData(wJoinAsData);
      }
      else {
        swal('Error', "Check API Something Wrong", 'error');

      }


    });

  }, []);

 

  useEffect(() => {
    const eventid = localStorage.getItem('eventid')
    axios.get(`api/modules-access?id=${eventid}`).then(res => {
      if (res.status === 200) {

        setassignModules(res.data.mod);
      }
    });

  }, []);


  const handlechnage = (e) => {
    const value = e.target.value;
    const checked = e.target.checked;
    if (checked) {
      setCheckedmodules([...checkmodules, value])
    }
    else {
      setCheckedmodules(checkmodules.filter((e) => (e !== value)));
    }

  }

  const handleJoinAs = (e) => {
    setjoinAs(e.target.value);
  }

  const handleNameTitle = (e) => {
    setNameTitle(e.target.value);
  }

  const handleInput = (e) => {
    setAddWorkShopParticpant({ ...addWorkShopParticpant, [e.target.name]: e.target.value });

  }


  const handleChange = (event) => {
    setGender(event.target.value);
  };

  const handleCountry = (e) => {
    setCountry(e.target.value);
  }
  const handleregistration = (e) => {
    setRegistrationType(e.target.value);
  }
  

  

  const addWorkshopParticipant = (e) => {
    e.preventDefault();

    const data = {
      eventid,
      checkmodules,
      nameTitle,
      joinAs,
      participant_name: addWorkShopParticpant.name,
      participant_saudi_council_no: addWorkShopParticpant.saudiCouncilno,
      participant_email: addWorkShopParticpant.email,
      participant_workshop_categoy: registrationType,
      participant_contact: addWorkShopParticpant.phone,
      participant_gender: gender,

      p_instituteWorkPlace: addWorkShopParticpant.instituteWorkPlace,
      participant_city: addWorkShopParticpant.city,
     
      participant_country: country,
      
      
     
      
      participant_price: addWorkShopParticpant.price,


      
    }

    console.log(data)
    // data.title == "" ? setdisabled(false) :
    //     data.descriptions == "" ? setdisabled(false) :
    //         setdisabled(true)

    axios.get('/sanctum/csrf-cookie').then(response => {

        axios.post(`/api/store-workshop-particpant-join`, data).then(res => {

            if (res.data.status === 200) {


                swal('Success', res.data.message, 'success');

                history.push('/admin/workshop/manage-particpant');
            }
            else {

                setAddWorkShopParticpant({ ...addWorkShopParticpant, error_list: res.data.validate_error })

            }

        });


    });


  }
  const [abstractHomeSetup, setAbstractHomeSetup] = useState({
    color_code: "",
    color_code_two: "",
    color_code_three: "",
    call_emergency: "",
    send_email: "",
    event_place: "",
    facebook_link: "",
    Instagram_link: "",
    linkedin_link: "",
    twitter_link: "",
    abstractFooterImage: "",
    abstractBannerImage: "",
    abstractSponserLogos: "",
    error_list: [],
});
React.useEffect(() => {
    axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
        if (res.status === 200) {
            const getHomePageData = res.data.HomePageSetup;
            setAbstractHomeSetup(getHomePageData);
        }
    })

}, [eventid]);



let backGroundButtonByEvent = "";
if (eventid) {
    backGroundButtonByEvent = `${abstractHomeSetup.color_code_two}`; // Assign the value conditionally
}
else {
    backGroundButtonByEvent = '#145348'; // Default background color
}
//backgroundColor: backGroundButtonByEvent,
  return (

    <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
      <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>
        <h4 sx={{ m: 2, color: '#000000' }} >
          <Button sx={{
            float: 'right',
            marginTop: '2%',
            backgroundColor: backGroundButtonByEvent,
            ":hover": {
              color: "white"
            }
          }}
            color='success'
            size='small'
            variant='contained'
            onClick={() => history.goBack()}>
            Back
          </Button>
          <Button sx={{
            float: 'right',
            marginRight: '1%',
            backgroundColor: backGroundButtonByEvent,
            marginTop: '2%',
            ":hover": {
              color: "white"
            }
          }}
            color='success'
            size='small'
            variant='contained'
            component={Link}
            to="/admin/particpant/join-as">
            Add Join As
          </Button>


        </h4>
        <Card sx={{ width: '60vw', float: 'center' }} >
          <CardContent >
            <Typography component="h1" variant="h5">
              Add WorkShop Participant
            </Typography>
            <Box component="form" onSubmit={addWorkshopParticipant} noValidate sx={{ mt: 3 }}>
              <Grid container spacing={4}>

                <Grid item xs={12} lg={6}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Title</InputLabel>
                    <Select
                      value={nameTitle}
                      onChange={handleNameTitle}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Action" >
                      <MenuItem value={'Mr'}>Mr</MenuItem>
                      <MenuItem value={'Mrs'}>Mrs</MenuItem>
                      <MenuItem value={'Ms'}> Ms</MenuItem>
                      <MenuItem value={'Dr'}>Dr </MenuItem>
                      <MenuItem value={'Prof'}>Prof</MenuItem>
                      <MenuItem value={'Eng'}>Eng </MenuItem>
                      <MenuItem value={'Sheikh'}>Sheikh</MenuItem>
                    </Select>
                    <FormHelperText></FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item xs={12} lg={6}>
                
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Join As</InputLabel>
                    <Select
                      value={joinAs}
                      onChange={handleJoinAs}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Action" >
                     {
                        workShopJoinAsData && workShopJoinAsData.map((val, index) => {
                          return (
                            <MenuItem value={val.id} key={val.id}>{val.join_as} </MenuItem>
                          )
                        })
                      }
                    </Select>
                    <FormHelperText></FormHelperText>
                  </FormControl>
                </Grid>
                

                <Grid item xs={6} >
                  <TextField
                    autoComplete="given-name"
                    required
                    fullWidth
                    label="Name"
                    autoFocus
                    name='name'
                    onChange={handleInput} value={addWorkShopParticpant.name}
                    helperText={addWorkShopParticpant.error_list.name} />
                </Grid>
                {/* <Grid item xs={6} >
                  <TextField
                    autoComplete="given-name"
                    required
                    fullWidth

                    label="Institute/Workplace"
                    autoFocus
                    name='instituteWorkPlace'
                    onChange={handleInput} value={addWorkShopParticpant.instituteWorkPlace}
                    helperText={addWorkShopParticpant.error_list.name} />
                </Grid> */}
                <Grid item xs={6} >
                  <FormControl>
                    <FormLabel id="demo-row-radio-buttons-group-label">Gender</FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={gender}
                      onChange={handleChange} >
                      <FormControlLabel value="male" control={<Radio />} label="Male" />
                      <FormControlLabel value="female" control={<Radio />} label="Female" />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                <Grid item xs={12} lg={6}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Country</InputLabel>
                    <Select
                      value={country || ""}
                      onChange={handleCountry}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Action" >
                      <MenuItem value={'Saudi Arabia'}>Saudi Arabia</MenuItem>
                      <MenuItem value={'UAE'}>UAE</MenuItem>
                      <MenuItem value={'Qatar'}> Qatar</MenuItem>
                      <MenuItem value={'Oman'}>Oman </MenuItem>
                      <MenuItem value={'Jordan'}>Jordan</MenuItem>
                      <MenuItem value={'Trurky'}>Trurky </MenuItem>

                    </Select>
                    <FormHelperText></FormHelperText>
                  </FormControl>
                </Grid>

                <Grid item xs={6} >
                  <TextField
                    autoComplete="given-name"
                    required
                    fullWidth
                    label="City"
                    autoFocus
                    name='city' onChange={handleInput} value={addWorkShopParticpant.city || ""} />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    required
                    fullWidth
                    label="Mobile"
                    type="text"
                    name='phone'
                    onChange={handleInput} value={addWorkShopParticpant.phone || ""} />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    required
                    fullWidth
                    id="email"
                    label="Email Address"
                    autoComplete="email"
                    name='email'
                    onChange={handleInput} value={addWorkShopParticpant.email}
                    helperText={addWorkShopParticpant.error_list.name} />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    required
                    fullWidth
                    label="Saudi Council No"
                    type="text"
                    name='saudiCouncilno'
                    onChange={handleInput} value={addWorkShopParticpant.saudiCouncilno || ""} />
                </Grid>
                {/* 
                <Grid item xs={12} lg={6}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Registration Type</InputLabel>
                    <Select
                      value={registrationType || ""}
                      onChange={handleregistration}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Action" >
                      <MenuItem value={'Free Registration'}>Free Registration</MenuItem>
                      <MenuItem value={'Consultants'}>Consultants</MenuItem>
                      <MenuItem value={'Fellows'}> Fellows</MenuItem>
                      <MenuItem value={'Residents'}>Residents </MenuItem>
                      <MenuItem value={'Other'}>Other </MenuItem>


                    </Select>
                    <FormHelperText></FormHelperText>
                  </FormControl>
                </Grid> */}
                <Grid item xs={12} lg={6}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Workshop Category</InputLabel>
                    <Select

                      value={registrationType || ""}
                      // onChange={handleWorkShopCategory}
                      onChange={handleregistration}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Workshop Category" >
                      {
                        workshopCategoryData && workshopCategoryData.map((val, index) => {
                          return (
                            <MenuItem value={val.id} key={val.id}>{val.workshop_category_title} </MenuItem>
                          )
                        })
                      }



                    </Select>

                    <FormHelperText>{addWorkShopParticpant.error_list.participant_workshop_categoy}</FormHelperText>
                  </FormControl>
                </Grid>
                {/* <Grid item xs={6}>
                  <TextField
                    required
                    fullWidth
                    label="Price"
                    type="text"
                    name='price'
                    onChange={handleInput} value={addWorkShopParticpant.price || ""} />
                </Grid> */}

                {/* <Grid item xs={12}>
                  <FormGroup row>
                    {
                      assignModule.map((item) => {
                        return (

                          <FormControlLabel required control={<Checkbox />}
                            label={item.module}
                            onChange={handlechnage}
                            value={item.module_id}
                            name="checkmodules" key={item.id} />

                        )
                      })
                    }
                  </FormGroup>
                  <FormHelperText>{addWorkShopParticpant.error_list.checkmodules} </FormHelperText>
                </Grid> */}


              </Grid>

              <Grid container justifyContent="flex-end">
                <Button
                  disabled={disabled}
                  type="submit"
                  // fullWidth
                  variant="contained"
                  sx={{ mt: 5, backgroundColor: backGroundButtonByEvent, }} >
                  Add Participant
                </Button>
              </Grid>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </div>

  );
}

export default AddWorkShopParticpant;
